var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1456 15.0137V29.5407C13.1456 33.1049 10.2294 36.0031 6.68315 36.0031C3.1189 36.0031 0.220703 33.1049 0.220703 29.5407C0.220703 25.9944 3.1189 23.0962 6.68315 23.0962C8.17725 23.0962 9.52735 23.6183 10.6254 24.4643V15.7337L13.1456 15.0137Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2257 9.57715V26.0663C32.2257 29.6305 29.3275 32.5287 25.7632 32.5287C22.217 32.5287 19.3008 29.6305 19.3008 26.0663C19.3008 22.52 22.217 19.6218 25.7632 19.6218C27.2753 19.6218 28.6254 20.1439 29.7235 21.0079V10.2972L32.2257 9.57715Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.2265 5.72481V9.57708L10.625 15.7335V8.55101C10.625 5.90482 12.2271 3.85268 14.7653 3.16864L25.17 0.32444C27.2761 -0.251599 29.0583 -0.053586 30.3184 0.918481C31.5964 1.87255 32.2265 3.49266 32.2265 5.72481Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAudio);
export default __webpack_public_path__ + "static/media/ic_audio.904712caf7549e1770d57b12d0e56e67.svg";
export { ForwardRef as ReactComponent };